import { APIS } from '@/constants';
import store from '@/store';

const wsBackendHandler = {
  onError(event) {
    console.warn('Backend WebSocket handler error:', event);
  },
  onMessage(event) {
    try {
      const eventData = JSON.parse(event.data);
      if (!eventData) return;
      _handleEvent({ event: eventData.event, data: eventData.data, id: eventData.id });
    } catch (error) {
      console.error('Error parsing backend WebSocket message:', error, event.data);
    }
  },
};

export default wsBackendHandler;

const _handleEvent = ({ event, data }) => {
  switch (event) {
    case 'ID':
      // Connection established, client ID assigned
      break;
    case APIS.WS.EVENTS.BACKEND_NEW_HEIGHT:
      _handleEventNewHeight(data);
      break;
    case APIS.WS.EVENTS.BACKEND_ACCOUNT_STATISTICS_UPDATE:
      _handleEventAccountStatisticsUpdate();
      break;
    case APIS.WS.EVENTS.BACKEND_TOKENS_CHART_UPDATE:
      _handleEventTokensChartUpdate(data);
      break;
    default:
      // Unhandled event
      break;
  }
};

const _handleEventNewHeight = (data) => {
  store.commit('application/setEventHeight', data);
  if (data.hasTxs) {
    store.commit('home/setTxEventHeight', data.height);
    store.commit('transactions/setTxEventHeight', data.height);
  }
};

const _handleEventAccountStatisticsUpdate = () => {
  // TODO: Implement account statistics handler if needed
};

const _handleEventTokensChartUpdate = (data) => {
  store.commit('home/setChartEventTokens', data);
};
